// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/circle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_pageContainer__HhJMt {
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
  width: 100%;
}
.styles_pageContainer__HhJMt.styles_showHeader__AoHls {
  min-height: calc(100vh - 200px);
}
@media (max-width: 480px) {
  .styles_pageContainer__HhJMt {
    padding: 24px 12px;
    min-height: calc(100vh - 80px);
    justify-content: flex-start;
    padding-top: 60px;
  }
}

.styles_circleIcon__Vk18t {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.styles_container__8XHLy {
  width: 600px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
  border-radius: 16px;
  gap: 24px;
  background-color: var(--color-white);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}
@media (min-width: 768px) {
  .styles_container__8XHLy {
    border-radius: 40px;
    padding: 40px;
  }
}
@media (max-width: 480px) {
  .styles_container__8XHLy {
    width: 100%;
    padding: 24px 16px;
    border-radius: 12px;
    gap: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/page-container/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AAAF;AAEE;EACE,+BAAA;AAAJ;AAIE;EAfF;IAgBI,kBAAA;IACA,8BAAA;IACA,2BAAA;IACA,iBAAA;EADF;AACF;;AAIA;EACE,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;AADF;;AAIA;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,oCAAA;EACA,yCAAA;EACA,sBAAA;AADF;AClCE;EDwBF;IAcI,mBAAA;IACA,aAAA;EAAF;AACF;AAGE;EAnBF;IAoBI,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,SAAA;EAAF;AACF","sourcesContent":["@import \"mixins\";\n.pageContainer {\n  min-height: calc(100vh - 100px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  box-sizing: border-box;\n  width: 100%;\n\n  &.showHeader {\n    min-height: calc(100vh - 200px);\n  }\n\n  // Mobile: reduce padding and min-height\n  @media (max-width: 480px) {\n    padding: 24px 12px;\n    min-height: calc(100vh - 80px);\n    justify-content: flex-start;\n    padding-top: 60px;\n  }\n}\n\n.circleIcon {\n  background-image: url('../../assets/circle.svg');\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.container {\n  width: 600px;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 16px;\n  border-radius: 16px;\n  gap: 24px;\n  background-color: var(--color-white);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n\n  @include md {\n    border-radius: 40px;\n    padding: 40px;\n  }\n\n  // Mobile: smaller container\n  @media (max-width: 480px) {\n    width: 100%;\n    padding: 24px 16px;\n    border-radius: 12px;\n    gap: 16px;\n  }\n}","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `styles_pageContainer__HhJMt`,
	"showHeader": `styles_showHeader__AoHls`,
	"circleIcon": `styles_circleIcon__Vk18t`,
	"container": `styles_container__8XHLy`
};
export default ___CSS_LOADER_EXPORT___;
